import "./main.css";
import {useSlotProps as $11MUV$useSlotProps, useStyleProps as $11MUV$useStyleProps, classNames as $11MUV$classNames, getWrappedElement as $11MUV$getWrappedElement} from "@react-spectrum/utils";
import {FocusRing as $11MUV$FocusRing} from "@react-aria/focus";
import {mergeProps as $11MUV$mergeProps, mergeRefs as $11MUV$mergeRefs} from "@react-aria/utils";
import $11MUV$react, {useRef as $11MUV$useRef} from "react";
import {useHover as $11MUV$useHover} from "@react-aria/interactions";
import {useLink as $11MUV$useLink} from "@react-aria/link";
import {useProviderProps as $11MUV$useProviderProps} from "@react-spectrum/provider";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



var $4564c6c10d1690b3$exports = {};

$parcel$export($4564c6c10d1690b3$exports, "focus-ring", () => $4564c6c10d1690b3$export$f39a09f249340e2a, (v) => $4564c6c10d1690b3$export$f39a09f249340e2a = v);
$parcel$export($4564c6c10d1690b3$exports, "i18nFontFamily", () => $4564c6c10d1690b3$export$8c4ee2c50c22c514, (v) => $4564c6c10d1690b3$export$8c4ee2c50c22c514 = v);
$parcel$export($4564c6c10d1690b3$exports, "is-disabled", () => $4564c6c10d1690b3$export$d35bc1e505d1ebbf, (v) => $4564c6c10d1690b3$export$d35bc1e505d1ebbf = v);
$parcel$export($4564c6c10d1690b3$exports, "is-hovered", () => $4564c6c10d1690b3$export$b8813cd5d7824ce7, (v) => $4564c6c10d1690b3$export$b8813cd5d7824ce7 = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-FocusRing-ring", () => $4564c6c10d1690b3$export$4109102f950813a6, (v) => $4564c6c10d1690b3$export$4109102f950813a6 = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-FocusRing", () => $4564c6c10d1690b3$export$24c7f46a6e3605dd, (v) => $4564c6c10d1690b3$export$24c7f46a6e3605dd = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-FocusRing--quiet", () => $4564c6c10d1690b3$export$2927016961429360, (v) => $4564c6c10d1690b3$export$2927016961429360 = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link", () => $4564c6c10d1690b3$export$d85dd8b94975f388, (v) => $4564c6c10d1690b3$export$d85dd8b94975f388 = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--overBackground", () => $4564c6c10d1690b3$export$679b6267148797da, (v) => $4564c6c10d1690b3$export$679b6267148797da = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--quiet", () => $4564c6c10d1690b3$export$81921ea93435e997, (v) => $4564c6c10d1690b3$export$81921ea93435e997 = v);
$parcel$export($4564c6c10d1690b3$exports, "spectrum-Link--secondary", () => $4564c6c10d1690b3$export$ab09ed292dcb9a79, (v) => $4564c6c10d1690b3$export$ab09ed292dcb9a79 = v);
var $4564c6c10d1690b3$export$f39a09f249340e2a;
var $4564c6c10d1690b3$export$8c4ee2c50c22c514;
var $4564c6c10d1690b3$export$d35bc1e505d1ebbf;
var $4564c6c10d1690b3$export$b8813cd5d7824ce7;
var $4564c6c10d1690b3$export$4109102f950813a6;
var $4564c6c10d1690b3$export$24c7f46a6e3605dd;
var $4564c6c10d1690b3$export$2927016961429360;
var $4564c6c10d1690b3$export$d85dd8b94975f388;
var $4564c6c10d1690b3$export$679b6267148797da;
var $4564c6c10d1690b3$export$81921ea93435e997;
var $4564c6c10d1690b3$export$ab09ed292dcb9a79;
$4564c6c10d1690b3$export$f39a09f249340e2a = `WBgRPa_focus-ring`;
$4564c6c10d1690b3$export$8c4ee2c50c22c514 = `WBgRPa_i18nFontFamily`;
$4564c6c10d1690b3$export$d35bc1e505d1ebbf = `WBgRPa_is-disabled`;
$4564c6c10d1690b3$export$b8813cd5d7824ce7 = `WBgRPa_is-hovered`;
$4564c6c10d1690b3$export$4109102f950813a6 = `WBgRPa_spectrum-FocusRing-ring`;
$4564c6c10d1690b3$export$24c7f46a6e3605dd = `WBgRPa_spectrum-FocusRing ${$4564c6c10d1690b3$export$4109102f950813a6}`;
$4564c6c10d1690b3$export$2927016961429360 = `WBgRPa_spectrum-FocusRing--quiet`;
$4564c6c10d1690b3$export$d85dd8b94975f388 = `WBgRPa_spectrum-Link`;
$4564c6c10d1690b3$export$679b6267148797da = `WBgRPa_spectrum-Link--overBackground`;
$4564c6c10d1690b3$export$81921ea93435e997 = `WBgRPa_spectrum-Link--quiet`;
$4564c6c10d1690b3$export$ab09ed292dcb9a79 = `WBgRPa_spectrum-Link--secondary`;





function $3c5235ac12f2c9bb$export$a6c7ac8248d6e38a(props) {
    props = (0, $11MUV$useProviderProps)(props);
    props = (0, $11MUV$useSlotProps)(props, "link");
    let { variant: variant = "primary", isQuiet: isQuiet, children: children, href: // @ts-ignore
    href } = props;
    let { styleProps: styleProps } = (0, $11MUV$useStyleProps)(props);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $11MUV$useHover)({});
    let ref = (0, $11MUV$useRef)();
    let { linkProps: linkProps } = (0, $11MUV$useLink)({
        ...props,
        elementType: !href && typeof children === "string" ? "span" : "a"
    }, ref);
    let domProps = {
        ...styleProps,
        ...(0, $11MUV$mergeProps)(linkProps, hoverProps),
        ref: ref,
        className: (0, $11MUV$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($4564c6c10d1690b3$exports))), "spectrum-Link", {
            "spectrum-Link--quiet": isQuiet,
            [`spectrum-Link--${variant}`]: variant,
            "is-hovered": isHovered
        }, styleProps.className)
    };
    let link;
    if (href) link = /*#__PURE__*/ (0, $11MUV$react).createElement("a", domProps, children);
    else {
        // Backward compatibility.
        let wrappedChild = (0, $11MUV$getWrappedElement)(children);
        link = /*#__PURE__*/ (0, $11MUV$react).cloneElement(wrappedChild, {
            ...(0, $11MUV$mergeProps)(wrappedChild.props, domProps),
            // @ts-ignore https://github.com/facebook/react/issues/8873
            ref: wrappedChild.ref ? (0, $11MUV$mergeRefs)(ref, wrappedChild.ref) : ref
        });
    }
    return /*#__PURE__*/ (0, $11MUV$react).createElement((0, $11MUV$FocusRing), {
        focusRingClass: (0, $11MUV$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($4564c6c10d1690b3$exports))), "focus-ring")
    }, link);
}




export {$3c5235ac12f2c9bb$export$a6c7ac8248d6e38a as Link};
//# sourceMappingURL=module.js.map
